import React, { useEffect } from "react";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import { makeStyles } from "@mui/styles";
import ClearIcon from "@mui/icons-material/Clear";
import { green, red } from "@mui/material/colors";

import CheckIcon from "@mui/icons-material/Check";
import { useLanguageContext } from "../../Context/LanguageContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "start",
    flexDirection: "column",
    position: "relative",
  },

  itemContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: theme.spacing(1),
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonStyleSucess: {
    backgroundColor: green[700],
    fontSize: 12,
  },
  buttonStyleFail: {
    backgroundColor: red[700],
    fontSize: 12,
  },
}));

export default function Summary(props) {
  const { localization } = useLanguageContext();
  const classes = useStyles();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { equipmentGrpId, equipmentGrpName, isKonst, isIndiviual } = props.data;

  const [percentage, setPercentage] = React.useState(0);
  const [isVisible, setIsVisible] = React.useState(false);
  const itemsState = [
    {
      key: "equipmentNamesCount",
      count: 0,
      label: localization.addEquipment,
      error: localization.errorEquipment,
      condationalError: [],
    },
    {
      key: "manufacturesCount",
      count: 0,
      label: localization.manufacturer,
      error: localization.errorHersteller,
      condationalError: [],
    },

    {
      key: "menusCount",
      count: 0,
      label: localization.menu,
      error: localization.errormenu,
      condationalError: [],
    },
    {
      key: "attributesCount",
      count: 0,
      label: localization.attribute,
      error: localization.errorattribute,
      condationalError: [],
    },
    {
      key: "testGroupsCount",
      count: 0,
      label: localization.pruefGroup,
      error: localization.errorpruefGroup,
      condationalError: [],
      notAddedCount: 0,
    },
    {
      key: "testPlanCount",
      count: 0,
      label: localization.pruefPlan,
      error: localization.errorpruefplan,
      condationalError: [],
      notAddedCount: 0,
    },
  ];

  const [eqGrpConfig, setEqGrpConfig] = React.useState(itemsState);

  useEffect(() => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getSummaryEqGrp(equipmentGrpId);
  }, []);

  useEffect(() => {
    function getSummarySuccess() {
      var res = equipmentGroupStore.getSummaryEqGrpResult();
      if (res) {
        let _items = eqGrpConfig.filter((item) => {
          return !(
            (isKonst && item.key === "testGroupsCount") ||
            (isIndiviual && item.key === "testPlanCount")
          );
        });
        let _taskCompleteTracker = 1;
        _items.map((item, index) => {
          if (item.key === "testPlanCount") {
            if (res[item.key] > 0) {
              if (res["publishTestPlanCount"] !== res[item.key]) {
                item["count"] = res[item.key];
                item["notAddedCount"] =
                  res[item.key] - res["publishTestPlanCount"];
                item["error"] = localization.errorTestPlanNotpublish;
              } else {
                item["count"] = res[item.key];
                if (item["count"] > 0) {
                  _taskCompleteTracker++;
                }
              }
            } else {
              item["count"] = res[item.key];
              if (item["count"] > 0) {
                _taskCompleteTracker++;
              }
            }
          } else if (item.key === "testGroupsCount" && !isIndiviual) {
            if (res["testGroupsWithoutTestPlan"].length > 0) {
              item["count"] = res[item.key];
              item["error"] = localization.errorTestGrpNoTestPlan;
              item["notAddedCount"] = res["testGroupsWithoutTestPlan"].length;
              item["condationalError"] = res["testGroupsWithoutTestPlan"];
            } else {
              item["count"] = res[item.key];
              if (item["count"] > 0) {
                _taskCompleteTracker++;
              }
            }
          } else {
            item["count"] = res[item.key];
            if (item["count"] > 0) {
              _taskCompleteTracker++;
            }
          }
        });
        const totalStep = isKonst ? (isIndiviual ? 5 : 6) : isIndiviual ? 6 : 7;
        setPercentage(((_taskCompleteTracker / totalStep) * 100).toFixed(0));

        setEqGrpConfig(_items);
        setIsVisible(true);
        setGlobalSpinner(false);
      }
    }

    function getSummaryFailure() {
      var res = equipmentGroupStore.getSummaryEqGrpResult();

      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_SUMMARY_EQ_GRP_SUCCESS,
      getSummarySuccess,
    );

    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_SUMMARY_EQ_GRP_FAILURE,
      getSummaryFailure,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_SUMMARY_EQ_GRP_SUCCESS,
        getSummarySuccess,
      );

      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_SUMMARY_EQ_GRP_FAILURE,
        getSummaryFailure,
      );
    };
  }, []);

  return (
    isVisible && (
      <div className="ml-auto mr-auto d-flex summaryMainDiv align-self-center">
        <div className="Summarydemo">
          <h1>{equipmentGrpName}</h1>

          <div className="buttonDemo">
            <p className="percentageDemo">{percentage}%</p>
            <span>{localization.complete}</span>
          </div>
        </div>
        <div className="seconDemo">
          <h2 className="secondDemoh">{localization.summary}</h2>
          <ul className="ulStyleDemo">
            {eqGrpConfig.map((item, index) => {
              if (item.notAddedCount && item.notAddedCount > 0) {
                return (
                  <li
                    key={index}
                    className="liDemoStyle d-flex flex-column summaryErrorStyle"
                  >
                    <div className="row ml-0 mr-0 w-100">
                      <ClearIcon
                        style={{
                          display: "inline-block",
                          marginRight: "12px",
                        }}
                      />

                      {item.label}
                      <div className="imageinter">
                        <p class="centerDicv">{item.count}</p>
                      </div>
                    </div>
                    <div className="row ml-0 mr-0 w-100 ml-2">
                      {item.condationalError.length > 0
                        ? item.condationalError.join(",") + " " + item.error
                        : item.notAddedCount + " " + item.error}
                    </div>
                  </li>
                );
              } else {
                return (
                  <li
                    key={index}
                    className={`liDemoStyle d-flex flex-column ${
                      item.count === 0
                        ? "summaryErrorStyle"
                        : "summarySuccessStyle"
                    }`}
                  >
                    <div className="row ml-0 mr-0 w-100">
                      {item.count !== 0 ? (
                        <CheckIcon
                          style={{
                            display: "inline-block",
                            marginRight: "12px",
                          }}
                        />
                      ) : (
                        <ClearIcon
                          style={{
                            display: "inline-block",
                            marginRight: "12px",
                          }}
                        />
                      )}
                      {item.label}
                      <div className="imageinter">
                        <p class="centerDicv">{item.count}</p>
                      </div>
                    </div>
                    {item.count === 0 && (
                      <div className="row ml-0 mr-0">{item.error}</div>
                    )}
                  </li>
                );
              }
            })}
          </ul>
        </div>
      </div>
    )
  );
}
